/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import React, { useState } from "react";
import {
  FirstColumn,
  SecondColumn,
  RowStyle,
} from "./SurveyChartCardStyles/SurveyChartCardStyles";
import PropTypes from "prop-types";
import { isTextOption } from "../../../../../../utils/surveyOptionTypeUtils";

import { HIGH_CONTRAST_COLOR_FOR_FG_ON_WHITE_BG_GRAPHICS } from "@untyped-shared/colors";

import PieChartGraph from "@untyped-shared/charts/pieChart/pieChart";
import SurveyChartData from "./SurveyChartData";
import SurveyCardFooter from "../SurveyCardFooter";

function SurveyChartCard({ question, textSize = 1.0 }) {
  const [activeIndex, setActiveIndex] = useState(-1);

  if (!question) return null;

  const options = question.options;
  const total = options.reduce((acc, option) => {
    if (isTextOption(option)) {
      return acc + (option.total_answers || 0);
    }
    return acc + (option.count || 0);
  }, 0);

  const data = options.map((option, index) => {
    const obj = { ...option };
    obj.name = option.text;
    if (isTextOption(option)) {
      obj.value = option.total_answers || 0;
    } else {
      obj.value = option.count || 0;
    }
    obj.percent = total === 0 ? 0 : (obj.value / total) * 100;
    obj.color =
      HIGH_CONTRAST_COLOR_FOR_FG_ON_WHITE_BG_GRAPHICS[
        index % HIGH_CONTRAST_COLOR_FOR_FG_ON_WHITE_BG_GRAPHICS.length
      ];
    return obj;
  });

  return (
    <RowStyle>
      <FirstColumn>
        <div className="survey-text-container">
          <SurveyChartData
            data={data}
            setActiveIndex={setActiveIndex}
            activeIndex={activeIndex}
            textSize={textSize}
          />
          <SurveyCardFooter total={total} textSize={textSize} />
        </div>
      </FirstColumn>
      <SecondColumn aria-hidden>
        <PieChartGraph
          data={data}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
          height={200}
          textSize={textSize}
        />
      </SecondColumn>
    </RowStyle>
  );
}

SurveyChartCard.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        count: PropTypes.number,
        total_answers: PropTypes.number,
      }),
    ).isRequired,
  }),
};

export default SurveyChartCard;
